export const layoutStyles = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 320px',
  gap: '20px',
  alignItems: 'start',
  '@media (max-width: 900px)': {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
};

export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 24px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const headerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginBottom: '4px',
};

export const titleStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const checklistStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const sendAlertStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '12px 14px',
  marginBottom: '12px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.error.main}`,
  backgroundColor: ({ palette }) => `${palette.error.main}14`,
  color: ({ palette }) => palette.error.main,
};

export const sendAlertIconStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: '1px',
};
